export const DEFAULT_SEARCH_PAGE_SIZE = 10000;
export const DEFAULT_SEARCH_SORTING = {};
